import React, { useState, useEffect, useMemo, useCallback } from 'react';
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import ThongKeApi from "service/ThongKe/ThongKeApi";
import { formatNumber2 } from '../../../../utils/currencyFormat';
import { getDate } from '../../../../utils/formatDate';
import { BtnXuatExcel } from '../../ThongKeChi/XuatExcelvaPrint/BtnXuatExcel';
import { ContentTable } from './ContentTable';
import { BtnIn } from '../XuatExcelvaPrint/BtnIn';
import { ModalIn } from '../XuatExcelvaPrint/ModalIn';
import ChiTietHopDong from "service/chiTietHopDongApi";
import ChiTietHopDongContainer from 'containers/Common/QuanLyChoVay/ChiTietHopDongContainerV2';
import CustomerDetail from 'containers/Common/Customer/customerDetail';
import { ModalChiTietHopDong } from '../../../NhanVay/ChiTietHopDong/ModalChiTietHopDong';

// Hàm cấu hình cột: Trả về className và align thay vì style cứng
const getColumnsForType = (type, totals = {}, phanQuyen = {}, onOpenModalIn) => {
    const lowerType = type.toLowerCase();

    const functionColumn = {
        header: 'In Phiếu',
        accessor: 'chucnang',
        className: 'flex-basis-5 flex-basis-5-sm',
        align: 'text-center',
        render: (item) => <BtnIn item={item} type={type} onOpenModalIn={onOpenModalIn} />
    };

    let columns = [];

    switch (lowerType) {
        case 'goc':
            columns = [
                { header: 'Ngày GĐ', accessor: 'NgayGiaoDich', className: 'flex-basis-15 flex-basis-15-sm', align: 'text-center', render: (item) => getDate(item.NgayGiaoDich) },
                { header: 'Tên khách hàng', accessor: 'TenKhachHang', className: 'flex-basis-25 flex-basis-25-sm', align: 'text-center', isCustomerLink: true },
                { header: 'Mã hợp đồng', accessor: 'MaHopDong', className: 'flex-basis-20 flex-basis-20-sm', align: 'text-center', isContractLink: true },
                { header: `Tiền chi gốc`, accessor: 'TienChiGoc', className: 'flex-basis-20 flex-basis-20-sm', align: 'text-right', render: (item) => formatNumber2(item.TienChiHienThi), sum: totals.totalChiGoc },
            ];
            break;
        case 'lai':
            columns = [
                { header: 'Ngày GĐ', accessor: 'NgayGiaoDich', className: 'flex-basis-15 flex-basis-15-sm', align: 'text-center', render: (item) => getDate(item.NgayGiaoDich) },
                { header: 'Tên khách hàng', accessor: 'TenKhachHang', className: 'flex-basis-25 flex-basis-25-sm', align: 'text-center', isCustomerLink: true },
                { header: 'Mã hợp đồng', accessor: 'MaHopDong', className: 'flex-basis-20 flex-basis-20-sm', align: 'text-center', isContractLink: true },
                { header: 'Tiền chi lãi', accessor: 'TienChiLai', className: 'flex-basis-20 flex-basis-20-sm', align: 'text-right', render: (item) => formatNumber2(item.TienChiHienThi), sum: totals.totalChiLai },
            ];
            break;
        case 'ngoaile':
            columns = [
                { header: 'Ngày', accessor: 'NgayGiaoDich', className: 'flex-basis-15 flex-basis-15-sm', align: 'text-center', render: (item) => getDate(item.NgayGiaoDich) },
                { header: 'Mã Ngoài Lề', accessor: 'MaNgoaiLe', className: 'flex-basis-20 flex-basis-20-sm', align: 'text-center' },
                { header: 'Người nộp tiền', accessor: 'TenKhachHang', className: 'flex-basis-25 flex-basis-25-sm', align: 'text-center' },
                { header: 'Loại phiếu', accessor: 'LoaiPhieu', className: 'flex-basis-15 flex-basis-15-sm', align: 'text-center', render: (item) => item.LoaiPhieu },
                { header: 'Số tiền chi', accessor: 'TienChi', className: 'flex-basis-20 flex-basis-20-sm', align: 'text-right', render: (item) => formatNumber2(item.TienChi), sum: totals.totalChiNgoaiLe },
            ];
            break;
        case 'khac':
            columns = [
                { header: 'Ngày GĐ', accessor: 'NgayGiaoDich', className: 'flex-basis-15 flex-basis-15-sm', align: 'text-center', render: (item) => getDate(item.NgayGiaoDich) },
                { header: 'Tên khách hàng', accessor: 'TenKhachHang', className: 'flex-basis-25 flex-basis-25-sm', align: 'text-center', isCustomerLink: true },
                { header: 'Mã HĐ', accessor: 'MaHopDong', className: 'flex-basis-15 flex-basis-15-sm', align: 'text-center', isContractLink: true },
                { header: 'Phí kho', accessor: 'PhiKho', className: 'flex-basis-15 flex-basis-15-sm', align: 'text-right', render: (item) => formatNumber2(item.PhiKho), sum: totals.totalPhiKho },
                { header: 'Phí khác', accessor: 'PhiKhac', className: 'flex-basis-15 flex-basis-15-sm', align: 'text-right', render: (item) => formatNumber2(item.PhiKhac), sum: totals.totalPhiKhac },
                { header: 'Tổng', accessor: 'TongTienChi', className: 'flex-basis-15 flex-basis-15-sm', align: 'text-right', render: (item) => formatNumber2(item.TienChiHienThi), sum: totals.totalChiKhac },
            ];
            break;
        case 'hoahong':
            columns = [
                { header: 'Ngày GĐ', accessor: 'NgayGiaoDich', className: 'flex-basis-15 flex-basis-15-sm', align: 'text-center', render: (item) => getDate(item.NgayGiaoDich) },
                { header: 'Tên khách hàng', accessor: 'TenKhachHang', className: 'flex-basis-25 flex-basis-25-sm', align: 'text-center', isCustomerLink: true },
                { header: 'Mã hợp đồng', accessor: 'MaHopDong', className: 'flex-basis-25 flex-basis-25-sm', align: 'text-center', isContractLink: true },
                { header: 'Hoa hồng', accessor: 'HoaHong', className: 'flex-basis-25 flex-basis-25-sm', align: 'text-right', render: (item) => formatNumber2(item.TienChiHienThi), sum: totals.totalChiHoaHong },
            ];
            break;
        default:
            columns = [];
    }
    if (phanQuyen?.chi_inphieuchi) {
        columns.push(functionColumn);
    }
    return columns;
};

export const TableDanhSach = ({ show, onHide, type, title, filters, phanQuyen }) => {
    const [data, setData] = useState({
        list: [],
        total: 0,
        totalChiGoc: 0,
        totalChiLai: 0,
        totalChiNgoaiLe: 0,
        totalChiKhac: 0,
        totalChiHoaHong: 0,
        totalPhiKhac: 0,
        totalPhiKho: 0
    });
    const [loading, setLoading] = useState(true);
    const [pageIndex, setPageIndex] = useState(1);
    const pageSize = 20;
    const [hideParent, setHideParent] = useState(false);
    const [showModalIn, setShowModalIn] = useState(false);
    const [modalInData, setModalInData] = useState(null);
    const [showModalHopDong, setShowModalHopDong] = useState(false);
    const [showModalKhachHang, setShowModalKhachHang] = useState(false);
    const [modalKhachHangData, setModalKhachHangData] = useState(null);
    const [hopDongDetail, setHopDongDetail] = useState(null);
    const [showModalNhanVay, setShowModalNhanVay] = useState(false);
    const [nhanVayItem, setNhanVayItem] = useState(null);

    const fetchDetails = useCallback(() => {
        setLoading(true);
        const params = {
            ...filters,
            CauHinhTaiSanId: filters?.CauHinhTaiSanId
                ? parseInt(filters.CauHinhTaiSanId, 10)
                : 0,
            LoaiVay: filters?.LoaiVay ? parseInt(filters.LoaiVay, 10) : 0,
            pageIndex,
            pageSize
        };
        ThongKeApi.getDetailsChi(type, params)
            .then(res => {
                if (res.status === 200 && res.data) {
                    setData({ ...res.data, list: res.data.List || [], total: res.data.iTotal || 0 });
                } else {
                    setData({ list: [], total: 0 });
                }
            })
            .catch(() => setData({ list: [], total: 0 }))
            .finally(() => setLoading(false));
    }, [type, filters, pageIndex]);

    useEffect(() => {
        if (show) setPageIndex(1);
    }, [show, type]);

    useEffect(() => {
        if (show) fetchDetails();
    }, [pageIndex, show, fetchDetails]);

    const handleOpenModalIn = (item) => { setModalInData(item); setShowModalIn(true); setHideParent(true); };
    const handleCloseModalIn = () => { setShowModalIn(false); setHideParent(false); };
    const handleOpenModalHopDong = (item) => {
        setShowModalHopDong(true); setHideParent(true);
        ChiTietHopDong.getChiTietHopDong1(item.ChoVayID).then((response) => setHopDongDetail(response.data));
    };
    const handleCloseModalHopDong = () => { setShowModalHopDong(false); setHideParent(false); setHopDongDetail(null); if (modalKhachHangData) { setShowModalKhachHang(true); } else { setHideParent(false); } };
    const handleOpenModalKhachHang = (item) => { setModalKhachHangData(item); setShowModalKhachHang(true); setHideParent(true); };
    const handleCloseModalKhachHang = () => { setShowModalKhachHang(false); setHideParent(false); setModalKhachHangData(null); };
    const handleOpenModalNhanVay = (item) => { setNhanVayItem(item); setShowModalNhanVay(true); setHideParent(true); };
    const handleCloseModalNhanVay = () => { setShowModalNhanVay(false); setHideParent(false); setNhanVayItem(null); if (modalKhachHangData) { setShowModalKhachHang(true); } else { setHideParent(false); } };
    const handleOpenHopDongFromCustomer = (itemGiaoDich) => () => {
        if (itemGiaoDich.NhanVayId && itemGiaoDich.NhanVayId > 0) {
            const itemMap = { ...itemGiaoDich, NhanVayID: itemGiaoDich.NhanVayId };
            setNhanVayItem(itemMap);
            setShowModalNhanVay(true);
            setShowModalKhachHang(false);
            return;
        }
        const choVayId = itemGiaoDich.ChoVayId || itemGiaoDich.ChoVayID;
        if (choVayId) {
            ChiTietHopDong.getChiTietHopDong1(choVayId).then((res) => {
                if (res && res.data) {
                    setHopDongDetail(res.data);
                    setShowModalHopDong(true);
                    setShowModalKhachHang(false);
                }
            });
        }
    };
    const columns = useMemo(() => getColumnsForType(type, data, phanQuyen, handleOpenModalIn), [type, data, phanQuyen]);

    return (
        <>
            <Modal show={show && !hideParent} onHide={onHide} size="xl" centered className="modal-new modal-fade">
                <Modal.Header>
                    <h4 className="modal-title color7-bold ml-1 mt-1">{title}</h4>
                    <button type="button" className="close-popup-new" onClick={onHide}>
                        <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-end mb-1">
                        {!loading && data.list.length > 0 && (
                            <BtnXuatExcel type={type} filters={filters} />
                        )}
                    </div>

                    <div className="Left808x200 Table-main-new css-table-ds">
                        <div className="table-mobile table-mobile-hover">
                            <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                                <div className="table-headers" style={{ alignItems: 'stretch' }}>
                                    <div className="custom-table-header color-do-bold text-center flex-basis-5 flex-basis-5-sm">
                                        STT<br />[{data.total}]
                                    </div>
                                    {columns.map(col => {
                                        const alignHeader = col.align === 'text-right' ? 'text-right' : (col.align === 'text-center' ? 'text-center' : 'text-left');
                                        return (
                                            <div
                                                key={col.accessor}
                                                className={`custom-table-header ${col.className} ${alignHeader}`}
                                                style={{ fontWeight: 'bold' }}
                                            >
                                                {col.header}
                                                {col.sum !== undefined && (
                                                    <>
                                                        <br />
                                                        <span style={{ color: 'red', fontSize: '0.9em' }}>
                                                            $ = {formatNumber2(col.sum)}
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="custom-table-body">
                                    {loading ? (
                                        <div className="text-center p-5">Đang tải...</div>
                                    ) : data.list.length === 0 ? (
                                        <div className="text-center p-5">Không có dữ liệu</div>
                                    ) : (
                                        <ContentTable
                                            phanQuyen={phanQuyen}
                                            list={data.list}
                                            total={data.total}
                                            columns={columns}
                                            pageIndex={pageIndex}
                                            pageSize={pageSize}
                                            onOpenModalHopDong={handleOpenModalHopDong}
                                            onOpenModalKhachHang={handleOpenModalKhachHang}
                                            onOpenModalNhanVay={handleOpenModalNhanVay}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {data.total > pageSize && (
                        <div className="row mt-1">
                            <div className="col-sm-12 col-md-6 d-flex align-items-center">
                                <span className="color7">Hiển thị {(pageIndex - 1) * pageSize + 1} - {Math.min(pageIndex * pageSize, data.total)} / {data.total}</span>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="d-flex justify-content-end">
                                    <Pagination
                                        activePage={pageIndex}
                                        itemsCountPerPage={pageSize}
                                        totalItemsCount={data.total}
                                        pageRangeDisplayed={5}
                                        onChange={(page) => setPageIndex(page)}
                                        itemClass="page-item border-none"
                                        linkClass="page-link border-none"
                                        activeClass="active"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            {showModalIn && modalInData && (
                <ModalIn show={showModalIn} onHide={handleCloseModalIn} thuChiId={modalInData.ThuChiId} type={type} />
            )}
            {showModalHopDong && hopDongDetail && (
                <ChiTietHopDongContainer show={showModalHopDong} onHide={handleCloseModalHopDong} data={hopDongDetail} setModalTaiSan={() => { }} />
            )}
            {showModalKhachHang && modalKhachHangData && (
                <CustomerDetail show={showModalKhachHang} onHide={handleCloseModalKhachHang} data={{ CustomerID: modalKhachHangData.CustomerID }} showChiTietHopDong={handleOpenHopDongFromCustomer}/>
            )}
            {showModalNhanVay && nhanVayItem && (
                <ModalChiTietHopDong show={showModalNhanVay} onHide={handleCloseModalNhanVay} nhanvayId={nhanVayItem.NhanVayID} item={nhanVayItem} />
            )}
        </>
    );
};
